import React from "react";
import legalFieldPageStyle from "./legalFieldPageStyle";
import Layout from "../../Layouts/Layout";
import Typography from "@mui/material/Typography";
import { legalFieldPageConfig } from "@/src/services/landingPageService";
import Container from "../../../components/Container/Container";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Helmet } from "react-helmet-async";
import YourServiceWorld from "@/src/components/Sections/Generic/YourServiceWorld/YourServiceWorld";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/system";
import TopicList from "@/src/components/Teaser/TopicList";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";
import Section from "@/src/components/Section/Section";

type LegalFieldPageProps = {
  productCategory: AbstractCase["productCategory"];
};

export default function LegalFieldPage({ productCategory }: LegalFieldPageProps) {
  const pageConfig = legalFieldPageConfig[productCategory];

  return (
    <Layout backgroundType={"landingpage"}>
      <Helmet>
        <title>{pageConfig.pageTitle}</title>
      </Helmet>
      <Section sx={{ paddingTop: { xs: "5rem", md: "10rem" } }}>
        <Container variant="md">
          <Grid container spacing={4}>
            <Grid
              size={{ xs: 12, md: 5 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography variant={"h1"}>{pageConfig.headline}</Typography>
              <Typography sx={{ paddingTop: "1rem" }}>{pageConfig.subtitle}</Typography>
            </Grid>

            <Grid size={{ xs: 12, md: 7 }}>
              <Box component="img" src={pageConfig.headlineImage} width={1600} height={1426} sx={legalFieldPageStyle.image} />
            </Grid>
          </Grid>
        </Container>
      </Section>
      <TopicList legalArea={pageConfig.headline} topics={pageConfig.topicList} />
      <YourServiceWorld />
      <CustomerFeedback />
    </Layout>
  );
}
